import { atom } from 'recoil';
import { IdentityType, IndetityFlowNavigate } from '../constants';
import {
	CompanyFormData,
	CompanyFormIsErrors,
	PaymentAddress,
	PersonalFormData,
} from './type';

export const ChooseUserIdentity = atom({
	key: 'choose-user-identity',
	default: IdentityType.Company,
});

export const SubscriptionIdentityNaviagtion = atom({
	key: 'subscription-identity-naviagtion',
	default: IndetityFlowNavigate.ChooseIdentity,
});

/**
 * __simplici_success_variant__: which flow reached the success screen.
 *
 * Two very different journeys end on IndetityFlowNavigate.Success — paying for a
 * subscription, and finishing identity verification, which takes no payment at
 * all. The screen used to assume the first and told everyone "Subscribed
 * successfully", which is untrue for the second. Set explicitly by whichever
 * flow navigates there rather than inferred from incidental state.
 */
export const IdentityFlowCompletion = atom<'subscription' | 'verification'>({
	key: 'identity-flow-completion',
	default: 'subscription',
});

/**
 * The server's reason when subscribing fails. The error screen used to show
 * only "Oops! Something went wrong" while the actual message — "Your account
 * is in under review", "No default card added" — went to a toast that had
 * already faded, so a refused payment read as an outage.
 */
export const IdentityFlowError = atom<string>({
	key: 'identity-flow-error',
	default: '',
});

/**
 * What Retry on the error screen re-posts. The subscribe journey retries
 * `POST /subscriptions`; the upgrade journey (SIM-52) must retry
 * `POST /business-registration {upgradeAccount}` instead. The two are not
 * interchangeable, and the completed KYB session behind a refused upgrade is
 * worth keeping on screen rather than closing the dialog and starting over.
 */
export const IdentityFlowRetry = atom<'subscribe' | 'upgrade'>({
	key: 'identity-flow-retry',
	default: 'subscribe',
});

export const ChooseServices = atom<string[]>({
	key: 'choose-services',
	default: [],
});

export const BusinessFormState = atom<CompanyFormData>({
	key: 'business-form-state1',
	default: {
		firstName : '',
		lastName : '',
		website: '',
		ein: '',
		companyName: '',
		email: '',
		phone: '',
		address: '',
		zip: '',
		city: '',
		country: '',
		state: '',
		linkedIn: 'https://www.linkedin.com/company/',
		countryCode: '',
	},
});

export const BusinessIsFormState = atom<CompanyFormIsErrors>({
	key: 'business-form-error-state',
	default: {
		firstName:false,
		lastName:false,
		website: false,
		ein: false,
		companyName: false,
		email: false,
		phone: false,
		address: false,
		zip: false,
		city: false,
		country: false,
		state: false,
		linkedIn: false,
	},
});

export const PersonalIsFormState = atom<Partial<CompanyFormIsErrors>>({
	key: 'persoanl-form-error-state',
	default: {
		firstName: false,
		lastName: false,
		email: false,
		phone: false,
		dob: false,
		zip: false,
		city: false,
		country: false,
		state: false,
		address: false,
		idNumber: false,
	},
});

export const BusinessIsFormErrorState = atom<CompanyFormData>({
	key: 'business-form-all-error-state',
	default: {
		firstName : '',
		lastName : '',
		website: '',
		ein: '',
		companyName: '',
		email: '',
		phone: '',
		address: '',
		zip: '',
		city: '',
		country: '',
		state: '',
		linkedIn: '',
	},
});

export const PersonalFormErrorState = atom<PersonalFormData>({
	key: 'perosnal-form-all-error-state',
	default: {
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		dob: '',
		zip: '',
		city: '',
		country: '',
		state: '',
		address: '',
		idNumber: '',
	},
});

export const PersonFormState = atom<PersonalFormData>({
	key: 'person-form-state1',
	default: {
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		dob: '',
		zip: '',
		city: '',
		country: '',
		state: '',
		address: '',
		idType: 'SSN',
		idNumber: '',
		countryCode: '',
	},
});

export const BillingPaymentAddress = atom<PaymentAddress>({
	key: 'billing-payment-address',
	default: {
		address1: '',
		city: '',
		state: '',
		zip: '',
		address2: '',
		country: '',
	},
});
